var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-input-group",
    { staticClass: "flex-nowrap" },
    [
      _c("Multiselect", {
        attrs: {
          placeholder: _vm.placeholder,
          multiple: "",
          label: "name",
          "track-by": "name",
          "hide-selected": true,
          options: _vm.items,
          "show-labels": false,
        },
        on: { input: _vm.itemsChanged },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }